import toString from 'lodash/toString';

import { TriggerCategory } from '@/modules/HealthPlan/HealthPlan.types';
import { RenewalDeductibleConfig, RenewalProcessingTier } from '@/modules/Renewals/renewals.types';

/**
 * A tier references at most one FAMILY and one EMBEDDED trigger. The
 * "Lock card purse" block is meaningful only for non-embedded triggers, so it
 * is hidden only when the tier is EMBEDDED-only (every referenced trigger is
 * EMBEDDED). A mixed tier (FAMILY + EMBEDDED) is NOT embedded-only and still
 * shows the block. A tier with no triggers is not embedded-only.
 */
export const isEmbeddedOnlyTier = (
  tier: RenewalProcessingTier,
  deductibleConfigs?: RenewalDeductibleConfig[]
): boolean => {
  const triggerIds = tier.tierTriggerIds || [];
  if (!triggerIds.length) return false;

  return triggerIds.every((id) =>
    (deductibleConfigs || []).some((config) =>
      (config.triggerConfigs || []).some(
        (triggerConfig) =>
          !!id &&
          toString(triggerConfig.triggerId) === toString(id) &&
          triggerConfig.triggerCategoryType === TriggerCategory.EMBEDDED
      )
    )
  );
};
